import APIService from './APIService.js';

export default {
  getReleases() {
    return APIService.apiCall().get('/releases/get-releases');
  },

  contarNaoVisualizadas() {
    return APIService.apiCall().get('/releases/contar-nao-visualizadas');
  },

  marcarVisualizado(id) {
    return APIService.apiCall().post(`/releases/marcar-visualizado/${id}`);
  },

  getReleasesAdmin() {
    return APIService.apiCall().get('/releases/admin/get-releases');
  },

  getReleaseById(id) {
    return APIService.apiCall().get(`/releases/admin/get-release/${id}`);
  },

  save(postData) {
    return APIService.apiCall().post('/releases/admin/save', JSON.stringify(postData));
  },

  publicar(id) {
    return APIService.apiCall().patch(`/releases/admin/publicar/${id}`);
  },

  despublicar(id) {
    return APIService.apiCall().patch(`/releases/admin/despublicar/${id}`);
  },

  deletar(id) {
    return APIService.apiCall().delete(`/releases/admin/deletar/${id}`);
  }
};
